import ListaEmpresaDto from './listaEmpresa.dto'
class Usuario {
    private static instance: Usuario

    public showMenu = false
    public nome = ''
    public cadastroPJ = null
    public empresaAndamento = null
    //public empresaSelecionada: Empresa  = new Empresa();
    public listaEmpresas: ListaEmpresaDto = new ListaEmpresaDto()
    public idMedico = null
    public idMedicoBasico = null
    public idUsuario = 1940
    public login = null
    public pathFoto = null
    public mensagens: Array<any> = []
    public mensagemCorporativa = {
        tipo: null,
        mensagens: Array<any>(),
    }
    public idCurrentMessage = 0
    public privilegios: any = null
    public perfil = {
        id: '',
        descricao: '',
        tipo: '',
    }
    public isPem = false
    public operacao = ''
    public operacoes: Array<any> = []

    /**
     * Método estático que controla o acesso à única instância do DTO
     *
     */
    public static getInstance(): Usuario {
        if (!Usuario.instance) {
            Usuario.instance = new Usuario()
        }

        return Usuario.instance
    }
    /**
     * Método para criar uma instancia nova do Usuario
     */
    public static createUsuario(usuarioTemp?: any): Usuario {
        if (usuarioTemp) {
            Usuario.instance = usuarioTemp
        } else {
            Usuario.instance = new Usuario()
        }
        return Usuario.instance
    }
}

export { Usuario }
export default Usuario
